import React from 'react';
import type { MealEntry } from '../../../types/mealTracking';
import { formatMealDisplayTime, resolveMealTitle } from '../mealTracking.utils';
import MealOverflowMenu from './MealOverflowMenu';
import styles from './MealCard.module.css';

interface MealCardProps {
  meal: MealEntry;
  onOpen: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const MealCard: React.FC<MealCardProps> = ({
  meal,
  onOpen,
  onEdit,
  onDelete,
}) => {
  const coverPhoto = meal.photos[0];

  const handleEditClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onEdit();
  };

  const handleMenuDelete = () => {
    onDelete();
  };

  return (
    <article className={styles.card} onClick={onOpen} role="button" tabIndex={0} onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onOpen();
      }
    }}>
      <div className={styles.time}>{formatMealDisplayTime(meal.time)}</div>

      <button
        type="button"
        className={styles.thumbnailButton}
        onClick={(event) => {
          event.stopPropagation();
          onOpen();
        }}
        aria-label={`Ver detalhes de ${resolveMealTitle(meal)}`}
      >
        {coverPhoto ? (
          <img src={coverPhoto.previewUrl} alt="" className={styles.thumbnail} />
        ) : (
          <span className={styles.thumbnailPlaceholder}>
            <span className="material-symbols-outlined" aria-hidden="true">photo_camera</span>
          </span>
        )}
      </button>

      <div className={styles.content}>
        <h2 className={styles.title}>{resolveMealTitle(meal)}</h2>
        <p className={styles.description}>{meal.description}</p>
      </div>

      <div className={styles.actions} onClick={(event) => event.stopPropagation()}>
        <button type="button" className={styles.editLink} onClick={handleEditClick}>
          Editar
        </button>
        <MealOverflowMenu onDelete={handleMenuDelete} />
      </div>
    </article>
  );
};

export default MealCard;
